import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import FormContainer from "../common/FormContainer";
import CheckoutSteps from "../common/CheckoutSteps";
import Meta from "../common/Meta";
import { savePaymentMethod } from "../../actions/bookingActions";

const PaymentScreen = () => {
  const navigate = useNavigate();

  const booking = useSelector((state) => state.booking);
  const { deliveryAddress } = booking;

  // if no delivery address return to delivery
  if (!deliveryAddress) {
    navigate("/delivery");
  }

  const [paymentMethod, setPaymentMethod] = useState("PayStack");

  const dispatch = useDispatch();

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(savePaymentMethod(paymentMethod));
    navigate("/placeorder");
  };

  return (
    <>
      <Meta title="Payment method" />
      <FormContainer>
        <CheckoutSteps step1 step2 step3 />
        <h1>Payment Method</h1>
        <Form onSubmit={submitHandler}>
          <Form.Group>
            <Form.Label as="legend">Select Method</Form.Label>

            <Col>
              <Form.Check
                type="radio"
                label="PayStack"
                id="PayStack"
                name="paymentMethod"
                value="PayStack"
                checked
                onChange={(e) => setPaymentMethod(e.target.value)}
              ></Form.Check>
              {/* <Form.Check
              type="radio"
              label="Stripe"
              id="Stripe"
              name="paymentMethod"
              value="Stripe"
              onChange={(e) => setPaymentMethod(e.target.value)}
            ></Form.Check> */}
            </Col>
          </Form.Group>
          <Button type="submit" variant="primary">
            Continue
          </Button>
        </Form>
      </FormContainer>
    </>
  );
};

export default PaymentScreen;
